import React, { useEffect } from 'react';
import './LandingPage.css';
import RouteLink from './RouteLink';

function LandingPage() {
  const heroImage = `${process.env.PUBLIC_URL || ''}/okhero.jpg`;

  useEffect(() => {
    const landing = document.querySelector('.landing');
    if (!landing) return;
    const handleScroll = () => {
      const offset = window.scrollY * 0.2;
      landing.style.setProperty('--hero-shift', `${offset}px`);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="landing">
      <header className="landing-nav">
        <div className="brand">
          <div className="brand-mark">SGS</div>
          <div className="brand-text">
            <span className="brand-name">Social Games Studio</span>
            <span className="brand-tag">Small studio, big community energy.</span>
          </div>
        </div>
        <div className="nav-actions">
          <RouteLink className="nav-link" to="/services">Services</RouteLink>
          <a className="nav-cta" href="#studio">Meet the studio</a>
        </div>
      </header>

      <main>
        <section className="hero" style={{ '--hero-image': `url(${heroImage})` }}>
          <div className="hero-copy">
            <p className="eyebrow">We build social-first games for real communities.</p>
            <h1>
              We develop social games and provide hosting that keeps them live, fast, and dependable.
            </h1>
            <p className="lead">
              We are a small studio focused on warm, replayable experiences that feel great to share. From
              design and development to hosting and live ops, we take care of the full stack so your players
              can just play.
            </p>
            <div className="cta-row">
              <RouteLink className="cta primary" to="/services">See what we do</RouteLink>
              <a className="cta ghost" href="#studio">Meet the studio</a>
            </div>
            <div className="hero-notes">
              <span>Small studio collaboration</span>
              <span>Social features baked in</span>
              <span>Hosting + live ops included</span>
            </div>
            <div className="hero-panel">
              <div className="panel-card">
                <h2>What we host</h2>
                <p>
                  Match flow, player accounts, and session services that keep social moments smooth.
                  We build for scale without losing the cozy feel.
                </p>
                <div className="panel-grid">
                  <div>
                    <span className="panel-label">Community</span>
                    <span className="panel-value">Clubs, invites, and gifting loops</span>
                  </div>
                  <div>
                    <span className="panel-label">Live Ops</span>
                    <span className="panel-value">Seasonal beats and themed drops</span>
                  </div>
                  <div>
                    <span className="panel-label">Reliability</span>
                    <span className="panel-value">Fast sessions with safe rollbacks</span>
                  </div>
                  <div>
                    <span className="panel-label">Analytics</span>
                    <span className="panel-value">Signals to tune engagement</span>
                  </div>
                </div>
              </div>
              <div className="panel-card accent">
                <h3>Small studio. Big care.</h3>
                <p>
                  You get direct access to the people building your game. We iterate fast, respond quickly,
                  and keep the experience human.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="pro-expert">
          <div className="pro-copy">
            <p className="eyebrow">Professional expert for every step</p>
            <h2>Professional expert for every step</h2>
            <p>
              A small, senior team that stays hands-on from concept to launch. We keep it light, clear, and
              collaborative while moving quickly.
            </p>
            <div className="pro-steps">
              <div>
                <span className="pro-step-title">Plan</span>
                <span className="pro-step-text">Audience, core loop, and social hooks.</span>
              </div>
              <div>
                <span className="pro-step-title">Design</span>
                <span className="pro-step-text">Playful systems, art direction, and feel.</span>
              </div>
              <div>
                <span className="pro-step-title">Build</span>
                <span className="pro-step-text">Fast iterations with stable hosting.</span>
              </div>
              <div>
                <span className="pro-step-title">Grow</span>
                <span className="pro-step-text">Events, content drops, and tuning.</span>
              </div>
            </div>
          </div>
          <div className="pro-image">
            <img src="/sudiodesign.webp" alt="Studio design workspace" />
          </div>
        </section>

        <section className="trailer">
          <div className="trailer-card">
            <div className="trailer-copy">
              <p className="eyebrow">Featured game</p>
              <h2>Cinna Bomber trailer</h2>
              <p>
                Take a quick look at our Cinnamon Bun Drop experience. The trailer plays only when you hit play.
              </p>
            </div>
            <div className="trailer-media">
              <video
                controls
                preload="metadata"
                src={`${process.env.PUBLIC_URL || ''}/CinnamonBunDrop/img/trailercinnabomber.mp4`}
              />
            </div>
          </div>
        </section>

        <section className="services-teaser">
            <div className="services-card">
              <div>
                <h2>Services</h2>
                <p>Custom social game design and hosting, delivered as a focused, friendly partnership.</p>
              </div>
              <RouteLink className="cta primary" to="/services">View the services page</RouteLink>
            </div>
          </section>

        <section id="studio" className="studio">
          <div className="studio-card">
            <h2>We are a small studio.</h2>
            <p>
              That means careful craftsmanship, quick communication, and work that feels personal. If you
              want a partner who can build and host your social game without the noise, we would love to talk.
            </p>
            <div className="studio-actions">
              <RouteLink className="cta primary" to="/services">Our services</RouteLink>
              <RouteLink className="cta ghost" to="/services">Learn about hosting</RouteLink>
            </div>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <div>Social Games Studio · Development + Hosting</div>
        <div>Made with care for social play.</div>
      </footer>
    </div>
  );
}

export default LandingPage;
